<template>
  <div class="big smartMedicalCare">
    <div class="page_title">智慧医疗</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 10px 20px 20px 20px;">

        <div class="top-header">
          <div class="search-box">
            <!-- 房号 -->
            <div class="item">
              <span>房号</span>
              <div class="item-content">
                <el-input v-model="smartMedicalCareForm.house_number"
                          size="small"
                          clearable
                          @keyup.enter.native="seachEnterFun"
                          placeholder="房号"></el-input>
              </div>
            </div>
            <!-- 设备编号 -->
            <div class="item">
              <span>设备编号</span>
              <div class="item-content">
                <el-input v-model="smartMedicalCareForm.device_id"
                          size="small"
                          clearable
                          @keyup.enter.native="seachEnterFun"
                          placeholder="设备编号"></el-input>
              </div>
            </div>

            <!--是否异常 -->
            <div class="item">
              <span>是否异常</span>
              <div class="item-content">
                <el-radio-group v-model="smartMedicalCareForm.is_abnormal">
                  <el-radio :label="-1">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </div>
              <el-button type="primary"
                         size="small"
                         style="margin-left:20px"
                         @click="getList">查询</el-button>
              <el-button size="small"
                         @click="restBtn">重置</el-button>
            </div>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table v-loading="tableLoading"
                    :data="smartMedicalCareData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column v-for="item in tableHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :fixed="item.fixed">
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'is_abnormal'">
                  {{ scope.row[item.prop] | abnormalText }}
                </div>
                <div v-else>
                  {{ JSON.stringify(scope.row[item.prop]) == 'null' ? '' : scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作"
                             width="220"
                             align="center"
                             fixed="right">

              <template slot-scope="scope">
                <el-button type="text"
                           size="medium"
                           @click="edit(scope.row)"
                           :disabled="module_id_array[0]?!module_id_array.includes('1344'):false">编辑</el-button>
                <el-button type="text"
                           :disabled="module_id_array[0]?!module_id_array.includes('1346'):false"
                           @click="delbtn(scope.row)">删除</el-button>
              </template>

            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination v-show="totalNum>0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getList" />
      </div>
    </div>
    <!-- 添加医生义诊活动 -->
    <el-dialog title="添加医生义诊活动"
               :visible.sync="eidtVisible"
               width="650px"
               :close-on-click-modal="false"
               custom-class="cus-visibilityVisible">
      <div style="text-align:left;padding:20px 100px 20px 20px;">
        <el-form :model="diaEditForm"
                 :rules="rules"
                 ref="diaEditRef"
                 label-width="80px"
                 class="visibilityVisible-ruleForm">
          <div class="cases-box">
            <el-form-item label="场所"
                          prop="place_id">
              <el-select v-model="diaEditForm.place_id"
                         size="small"
                         clearable
                         placeholder="请选择"
                         style="width:100%">
                <el-option v-for="item in placeList"
                           :key="item.place_id"
                           :label="item.place_name"
                           :value="item.place_id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="房号"
                          prop="house_number">
              <el-input v-model="diaEditForm.house_number"
                        size="small"
                        clearable
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="设备编号"
                          prop="device_id"
                          disabled>
              <el-input v-model="diaEditForm.device_id"
                        size="small"
                        clearable
                        disabled
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="激活时间"
                          prop="create_time">
              <el-input v-model="diaEditForm.create_time"
                        disabled
                        size="small"
                        clearable
                        placeholder="请输入"></el-input>
            </el-form-item>

          </div>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="eidtVisible=false"
                   size="medium"
                   plain>取 消</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="diaEditConfirm('diaEditRef')">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import department from '@/api/department.js';
import Pagination from '@/components/Pagination/index';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      tableHeader: [
        {
          label: '场所',
          prop: 'place_name',
          width: 'auto',
          align: 'center',
          fixed: 'left'
        },
        {
          label: '房号',
          prop: 'house_number',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '设备编号',
          prop: 'device_id',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '激活时间',
          prop: 'create_time',
          width: '200',
          align: 'center',
          fixed: false
        },
        {
          label: '是否异常',
          prop: 'is_abnormal',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      smartMedicalCareData: [],
      smartMedicalCareForm: {
        house_number: '',
        device_id: '',
        is_abnormal: -1
      },
      eidtVisible: false,
      placeList: [],
      diaEditForm: {
        place_name: '',
        place_id: '',
        house_number: '',
        device_id: '',
        create_time: ''
      },
      rules: {
        place_name: [
          { required: true, message: '请选择场所', trigger: 'blur' }
        ],
        house_number: [
          {
            required: true,
            max: 50,
            message: '请输入50个字符以内的房号',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:ss');
    },
    abnormalText(val) {
      switch (val) {
        case 0:
          return '否';

        case 1:
          return '是';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getPlaceList();
    this.getList();
  },
  methods: {
    // 获取场所列表
    getPlaceList() {
      department.getPlaceList().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.placeList = data;
        }
      });
    },
    getList() {
      let params = Object.assign(this.pagination, this.smartMedicalCareForm);
      this.tableLoading = true;
      department.getHouseListPaing(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.smartMedicalCareData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    restBtn() {
      for (let key in this.smartMedicalCareForm) {
        if (key == 'is_abnormal') {
          this.smartMedicalCareForm[key] = -1;
        } else {
          this.smartMedicalCareForm[key] = '';
        }
      }
      this.getList();
    },
    //删除
    delbtn(row) {
      let { log_id } = row;
      this.$confirm('删除后，客户端将重新进行激活，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const loading = this.$loading();
          department
            .deleteActiveLog({ log_id })
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success('删除成功');
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    // 编辑
    edit(row) {
      this.diaEditForm = Object.assign({}, this.diaEditForm, row);
      this.diaEditForm.create_time = dayjs
        .unix(this.diaEditForm.create_time)
        .format('YYYY-MM-DD HH:ss');
      this.eidtVisible = true;
    },
    // 确认提交
    modifyActiveLog() {
      const loading = this.$loading();
      let params = Object.assign({}, this.diaEditForm);
      params = _.pick(params, ['log_id', 'place_id', 'house_number']);
      department
        .modifyActiveLog(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            if (data.code == -2) {
              this.$confirm('当前房号已存在，确定修改吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
              })
                .then(() => {
                  this.modifyActiveLog();
                })
                .catch(() => {});
            } else {
              this.$message.success('修改成功');
              this.eidtVisible = false;
              this.getList();
            }
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    diaEditConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.modifyActiveLog();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.smartMedicalCare {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      margin-left: 10px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>